import { ChangeDetectorRef, Component, EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FeatureType } from 'src/app/components/featured-plates/featured-plates.component';
import { SidebarFilterConfig } from 'src/app/components/side-bar-filters/side-bar-filters.component';
import { StickyConfig, StickyLink, StickyLinkGroup } from 'src/app/components/sticky-tabs/sticky-tabs.component';
import { CompareFilters } from 'src/app/components/tp-sellers/tp-sellers.component';
import { DVLAVehicleEnquiryResult } from 'src/app/models/dvlaVehicleEnquiryResult';
import { FormattedPlateResponse } from 'src/app/models/formattedPlateResponse';
import { HttpLoadingResp } from 'src/app/models/httpLoadingResp';
import { PlateDetail } from 'src/app/models/plateDetail';
import { EditorialArticle } from 'src/app/models/editorial/editorialArticle';
import { EDITORIAL_PUBLIC_ENABLED } from 'src/app/models/editorial/editorialFeatureFlag';
import { Registration } from 'src/app/models/registration';
import { EditorialService } from 'src/app/services/editorial-service';
import { ImageKeyPair, ImageService } from 'src/app/services/image-service';
import { RegistrationService, RoiMetrics } from 'src/app/services/registration-service';
import { TrackingService } from 'src/app/services/tracking-service';
import { UserService } from 'src/app/services/user-service';

@Component({
  selector: 'pla-plate-detail-page',
  templateUrl: './plate-detail-page.component.html',
  styleUrls: ['./plate-detail-page.component.scss']
})
export class PlateDetailPageComponent implements OnInit {

  public searchedTerm: string = null;
  public registrationString: string = null;
  public formattedRegistration: string = null;
  public favouritePlate: Registration;
  public registrationLoaded: boolean = false;
  public showFullSearch: boolean = false;
  public notified: boolean = false;
  public notifiedFetch: boolean = false;
  public stickyLinkConfig: StickyConfig = new StickyConfig(
    [new StickyLinkGroup(
      [
        new StickyLink('Prices', 'compare-deals', true),
        new StickyLink('History', 'history', false),
        // new StickyLink('Market Insights', 'market-insight', false),
        // new StickyLink('Q&As', 'faq', false),
      ])],
    new EventEmitter<void>()
  );
  public rsFeatured = new FeatureType('Recently Sold', 'recently-sold');
  public selectedImage: ImageKeyPair = undefined;
  public compareFilters = new EventEmitter<
    SidebarFilterConfig<CompareFilters>
  >();
  public visibleChartData: { showingChart: boolean; showingTable: boolean } =
    undefined;
  public registeredVehicleInfo: HttpLoadingResp<DVLAVehicleEnquiryResult> =
    new HttpLoadingResp();
  public isRegisteredToVehicle: boolean = false;
  public roiMetrics: RoiMetrics = null;
  public editorial: EditorialArticle = null;

  public detail: {
    min: number;
    max: number;
    lastUpdate: Date;
    plateDetail: PlateDetail;
    loaded: boolean;
  } = {
      min: 0,
      max: 0,
      lastUpdate: new Date(),
      plateDetail: undefined,
      loaded: false
    };

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private registrationService: RegistrationService,
    private imageService: ImageService,
    private userService: UserService,
    private changeRef: ChangeDetectorRef,
    private trackingService: TrackingService,
    private editorialService: EditorialService
  ) {
    this.registrationString = this.activatedRoute.snapshot.params.registration;
    this.searchedTerm = this.activatedRoute.snapshot.params.term;
    this.showFullSearch =
      this.activatedRoute.snapshot.queryParams['_l'] == 'direct';
    if (this.registrationString == '' || this.registrationString == null)
      this.router.navigate(['/landing']);

    this.registrationString = this.registrationString
      .toUpperCase()
      .replace(' ', '');
    this.userService.getUserNotifies(() => {
      this.notified = this.registrationService.isNotify(
        this.registrationString
      );
      this.notifiedFetch = true;
    });
  }

  ngOnInit(): void {
    this.GetDetail();
    this.formatInput();
    this.GetEditorial();
  }

  // Fetch the approved editorial (if any). 404 => no editorial yet.
  // Gated by a temporary kill-switch: while OFF we make zero network calls.
  private GetEditorial(): void {
    if (!EDITORIAL_PUBLIC_ENABLED) return;
    this.editorialService.getApprovedEditorial(this.registrationString).subscribe(
      (article) => {
        if (!article) return;
        this.editorial = article;
        this.stickyLinkConfig.groups[0].links.push(
          new StickyLink('Story', 'editorial', false)
        );
      },
      () => {
        this.editorial = null;
      }
    );
  }

  public CompareResultsChange(firstLoad: boolean): void {
    console.log('compare results change', this.formattedRegistration, this.detail)
    this.registrationService.formatRegistrationFromString(this.formattedRegistration, this.detail.min, this.detail.min > -1, (_r) => {
      this.favouritePlate = _r;
    });
    if (firstLoad) return;
    setTimeout(() => {
      this.stickyLinkConfig.reScroll.emit();
    }, 100);
  }

  public SetCompareFilters(
    compareFilters: SidebarFilterConfig<CompareFilters>
  ): void {
    this.compareFilters.emit(compareFilters);
  }


  public PriceRangeChange(data: { min: number; max: number }): void {
    this.detail = { ...this.detail, min: data.min, max: data.max, loaded: true };
  }

  private GetDetail(): void {
    console.log('get detail', this.registrationString);
    this.registrationService
      .getPlateDetail(this.registrationString)
      .subscribe((d) => {
        this.detail = { ...this.detail, plateDetail: d, loaded: true };
        console.log(this.detail);
        this.fetchRegisteredVehicleInfo();
      });
  }

  public chartDataUpdate(event: any): void {
    console.log('chart data', event);
    this.visibleChartData = event;
    if (event.roiMetrics != null) {
      this.roiMetrics = event.roiMetrics;
    }
  }

  private fetchRegisteredVehicleInfo(): void {
    if (!this.registrationString || this.registrationString == '' || this.registrationString == null) return;
    this.registrationService
      .getVehicleInfo(this.registrationString.replace(' ', ''))
      .subscribe(
        (_: DVLAVehicleEnquiryResult) => {
          this.registeredVehicleInfo.Update(false, _);
          this.isRegisteredToVehicle = _ != null;
        },
        () => {
          this.registeredVehicleInfo.Update(false, null);
        }
      );
  }

  private formatInput(): void {
    this.registrationLoaded = false;
    this.registrationService
      .FormatRegistration(this.registrationString)
      .subscribe((formattedResp: FormattedPlateResponse) => {
        this.registrationLoaded = true;
        if (
          formattedResp.formattedRegistration == null ||
          formattedResp.formattedRegistration == ''
        )
          return;
        this.formattedRegistration = formattedResp.formattedRegistration;
        this.generateQuickImage();
      });
  }

  private generateQuickImage(): void {
    if (this.formattedRegistration == '') this.formattedRegistration = 'PLA 73X';
    this.imageService.INIT();
    this.imageService.quickBuild(
      this.imageService.getQuickConfig(),
      this.formattedRegistration,
      (image: ImageKeyPair) => {
        this.selectedImage = image;
      }
    );
  }

  public sourceById(id: number) {
    if (!this.editorial) return undefined;
    return (this.editorial.sources || []).find((s) => s.id === id);
  }

  public searchableUrl(): string {
    if (this.searchedTerm === '' || this.searchedTerm == undefined) return undefined;
    return `/search-results/${this.searchedTerm}`;
  }
  public searchAllClickHandler(): void {
    this.router.navigate([`/search-results/${this.registrationString}`]);
  }

}
